import {
  CreateTextRenderingObjectInput,
  RenderingObjectKind,
  RenderingObjectText,
} from "../../generated/gql/graphql";
import { CanvasObjectBase } from "../layout/editor/canvas-object";

export type CanvasObjectText = CanvasObjectBase & {
  kind: RenderingObjectKind.Text;
} & {
  text: Omit<NonNullable<RenderingObjectText["text"]>, "id">;
  bold?: boolean;
  color?: string;
};

export const DefaultText: Omit<CanvasObjectText["text"], "id"> = {
  fontId: null,
  content: "New Text",
  color: "#000000",
  width: 100,
  height: 50,
  alignHorizontal: null,
  alignVertical: null,
};

export function toTextUpdateInput(
  text: CanvasObjectText["text"],
): CreateTextRenderingObjectInput {
  return {
    fontId: text.fontId,
    content: text.content,
    color: text.color,
    width: text.width,
    height: text.height,
    alignHorizontal: text.alignHorizontal,
    alignVertical: text.alignVertical,
  };
}
